/* ── Custom cursor ── */
(function(){
  const cursor = document.getElementById('cursor');
  const ring = document.getElementById('cursor-ring');
  if(!cursor || !ring) return;
  let hasMouse = false;
  window.addEventListener('mousemove', function(e){
    if(!hasMouse){ hasMouse = true; document.body.classList.add('has-mouse'); }
    cursor.style.left = e.clientX + 'px';
    cursor.style.top = e.clientY + 'px';
    setTimeout(function(){
      ring.style.left = e.clientX + 'px';
      ring.style.top = e.clientY + 'px';
    }, 60);
  });
  document.addEventListener('mouseover', function(e){
    if(e.target.closest('a,button,.prod,.benefit,.v-card,.cloud-hero,.t-card')){
      cursor.style.width = '18px'; cursor.style.height = '18px';
      ring.style.width = '56px'; ring.style.height = '56px';
    }
  });
  document.addEventListener('mouseout', function(e){
    if(e.target.closest('a,button,.prod,.benefit,.v-card,.cloud-hero,.t-card')){
      cursor.style.width = '10px'; cursor.style.height = '10px';
      ring.style.width = '38px'; ring.style.height = '38px';
    }
  });
})();

/* ── Hero particle canvas (only runs if present on the page) ── */
(function(){
  const canvas = document.getElementById('heroCanvas');
  if(!canvas) return;
  const hero = canvas.parentElement;
  function resizeCanvas(){ canvas.width = hero.offsetWidth; canvas.height = hero.offsetHeight; }
  resizeCanvas();
  window.addEventListener('resize', resizeCanvas);
  const ctx = canvas.getContext('2d');
  const dots = [];
  for(let i = 0; i < 55; i++){
    dots.push({
      x: Math.random() * canvas.width, y: Math.random() * canvas.height,
      r: Math.random() * 2.5 + 0.5,
      vx: (Math.random() - .5) * .4, vy: (Math.random() - .5) * .4,
      o: Math.random() * .18 + .04,
      c: Math.random() > .5 ? '107,63,160' : '224,80,138'
    });
  }
  const mouse = { x: null, y: null };
  hero.addEventListener('mousemove', function(e){
    const r = canvas.getBoundingClientRect();
    mouse.x = e.clientX - r.left; mouse.y = e.clientY - r.top;
  });
  hero.addEventListener('mouseleave', function(){ mouse.x = null; mouse.y = null; });
  function animateDots(){
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    dots.forEach(function(d){
      d.x += d.vx; d.y += d.vy;
      if(mouse.x){
        const dx = mouse.x - d.x, dy = mouse.y - d.y, dist = Math.sqrt(dx*dx + dy*dy);
        if(dist < 120){ d.x -= dx * .015; d.y -= dy * .015; }
      }
      if(d.x < 0 || d.x > canvas.width) d.vx *= -1;
      if(d.y < 0 || d.y > canvas.height) d.vy *= -1;
      ctx.beginPath(); ctx.arc(d.x, d.y, d.r, 0, Math.PI*2);
      ctx.fillStyle = 'rgba(' + d.c + ',' + d.o + ')'; ctx.fill();
    });
    for(let i = 0; i < dots.length; i++){
      for(let j = i+1; j < dots.length; j++){
        const dx = dots[i].x - dots[j].x, dy = dots[i].y - dots[j].y, dist = Math.sqrt(dx*dx + dy*dy);
        if(dist < 110){
          ctx.beginPath(); ctx.moveTo(dots[i].x, dots[i].y); ctx.lineTo(dots[j].x, dots[j].y);
          ctx.strokeStyle = 'rgba(107,63,160,' + (.12 * (1 - dist/110)) + ')';
          ctx.lineWidth = .5; ctx.stroke();
        }
      }
    }
    requestAnimationFrame(animateDots);
  }
  animateDots();
})();

/* ── Nav scroll shadow ── */
(function(){
  const navbar = document.getElementById('navbar');
  if(!navbar) return;
  window.addEventListener('scroll', function(){
    navbar.classList.toggle('scrolled', window.scrollY > 40);
  });
})();

/* ── Scroll reveal (re-observes whenever new .reveal nodes are added, e.g. after the shop grid or cart renders) ── */
const revealObs = new IntersectionObserver(function(entries){
  entries.forEach(function(e){
    if(e.isIntersecting){ e.target.classList.add('visible'); revealObs.unobserve(e.target); }
  });
}, { threshold: 0.12 });
function observeReveals(){
  document.querySelectorAll('.reveal:not(.visible)').forEach(function(el){ revealObs.observe(el); });
}
document.addEventListener('DOMContentLoaded', observeReveals);

/* ── Countdown (only runs if present on the page) ── */
(function(){
  const el = document.getElementById('countdown');
  if(!el) return;
  const target = new Date();
  target.setDate(target.getDate() + 4);
  target.setHours(target.getHours() + 12);
  function pad(n){ return String(n).padStart(2, '0'); }
  function tick(){
    let d = target - new Date(); if(d < 0) d = 0;
    const days = Math.floor(d / 86400000);
    const h = Math.floor(d / 3600000) % 24;
    const m = Math.floor(d / 60000) % 60;
    const s = Math.floor(d / 1000) % 60;
    el.textContent = pad(days) + ':' + pad(h) + ':' + pad(m) + ':' + pad(s);
  }
  tick(); setInterval(tick, 1000);
})();

/* ── 3D model logo hide (only runs if present on the page) ── */
(function(){
  const mv = document.getElementById('hero-model');
  if(!mv) return;
  mv.addEventListener('load', function(){
    try{
      const scene = mv.model; if(!scene) return;
      const hide = /(misoka|logo)/i;
      if(scene.materials && scene.materials.length){
        scene.materials.forEach(function(mat){
          if(mat && mat.name && hide.test(mat.name)){
            try{ mat.setAlphaMode('BLEND'); mat.pbrMetallicRoughness.setBaseColorFactor([0,0,0,0]); }catch(e){}
          }
        });
      }
    }catch(e){}
  });
})();

/* ── Tilt on product cards (event delegation so it works on cards rendered dynamically by cart.js) ── */
(function(){
  document.addEventListener('mousemove', function(e){
    const card = e.target.closest('.prod');
    if(!card) return;
    const img = card.querySelector('.img');
    if(!img) return;
    const r = card.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width - .5;
    const y = (e.clientY - r.top) / r.height - .5;
    img.style.transform = 'perspective(600px) rotateY(' + (x*6) + 'deg) rotateX(' + (-y*6) + 'deg)';
  });
  document.addEventListener('mouseleave', function(e){
    if(e.target && e.target.classList && e.target.classList.contains('prod')){
      const img = e.target.querySelector('.img');
      if(img) img.style.transform = '';
    }
  }, true);
})();

/* Note: the newsletter and contact forms in this theme use Shopify's native
   'customer' and 'contact' form tags (see sections/newsletter.liquid and
   sections/contact.liquid). Those submit to Shopify directly and render
   form.posted_successfully? / form.errors server-side, so no client-side
   interception is needed or wanted here. */
